import React, { useState } from "react";
import "./ProductTab.css";

const ProductTabs = () => {
  const [activeTab, setActiveTab] = useState("description");

  return (
    <div className="tabs-container">
      {/* Tabs */}
      <div className="tabs-header">
        <span
          className={activeTab === "description" ? "active" : ""}
          onClick={() => setActiveTab("description")}
        >
          Description
        </span>

        <span
          className={activeTab === "additional" ? "active" : ""}
          onClick={() => setActiveTab("additional")}
        >
          Additional Information
        </span>

        <span
          className={activeTab === "return exchange policy" ? "active" : ""}
          onClick={() => setActiveTab("return exchange policy")}
        >
          Return Exchange Policy
        </span>

        <span
          className={activeTab === "reviews" ? "active" : ""}
          onClick={() => setActiveTab("reviews")}
        >
          Reviews [5]
        </span>
      </div>

      {/* Content */}
      <div className="tabs-content">
        {/* =====================================================
            DESCRIPTION
        ====================================================== */}
        {activeTab === "description" && (
          <>
            <p>
              Crafted with precision and care, this saree showcases fine
              handwork by skilled artisans. The soft, breathable fabric ensures
              all-day comfort, while the elegant design enhances your overall
              look. A perfect choice for those who value quality, authenticity,
              and timeless style.
            </p>

            <p>
              Experience timeless elegance with this beautifully handcrafted
              saree, designed to make every moment special. Made from
              premium-quality fabric and detailed with intricate hand
              embroidery, it offers unmatched comfort and grace. Perfect for
              weddings, festive occasions, and celebrations, this saree is a
              blend of tradition and modern sophistication.
            </p>
          </>
        )}

        {/* =====================================================
            ADDITIONAL INFORMATION
        ====================================================== */}
        {activeTab === "additional" && (
          <p>Here you can add fabric, size, weight, and care details.</p>
        )}

        {/* =====================================================
            RETURN & EXCHANGE POLICY
        ====================================================== */}
        {activeTab === "return exchange policy" && (
          <div className="return-exchange-policy">
            <h3>Refund and Exchange Policies:</h3>

            <p>
              <strong>
                Customers are required to record an opening/unboxing video at
                the time of delivery.
              </strong>
            </p>

            <p>
              <strong>
                This video is necessary to process any claims related to
                defective or incorrect products.
              </strong>
            </p>

            <ul>
              <li>
                We offer a hassle-free <strong>2-days</strong> (from the date of
                delivery) return and exchange for products bought at MRP only on
                New Products.
              </li>

              <li>
                Products on sale (offer products) are not refundable or
                exchangeable.
              </li>

              <li>
                Only exchange (same or higher value of any product) requests
                will be accepted for products bought during sales or at
                discounted prices.
              </li>

              <li>
                Items will be considered for exchange only if it is unused,
                unaltered and with all tags still attached.
              </li>

              <li>
                Returns that are damaged or soiled or without tags may not be
                accepted and may be sent back to the customer.
              </li>

              <li>
                Complaints regarding defective or incorrect products and
                incomplete orders should be raised within{" "}
                <strong>24 hours</strong> of receiving the products. Please
                share an image or video highlighting your concern.
              </li>

              <li>
                For all such queries, please write to us at{" "}
                <a href="mailto:saprahouseofelan@gmail.com">
                  saprahouseofelan@gmail.com
                </a>
              </li>
            </ul>

            {/* SELF SHIPPING */}
            <h4>Self-shipping</h4>

            <p>
              In case we do not have pick-up service available at your location,
              you would have to self-ship the product. A maximum of
              <strong> INR 100</strong> would be given to you as a credit note
              for reverse shipping.
            </p>

            {/* NON RETURNABLE ITEMS */}
            <h4>Non-returnable Items:</h4>

            <ol>
              <li>Gift wrap cannot be returned or exchanged.</li>

              <li>Shipping and COD charges are non-refundable.</li>

              <li>Sale items are not exchangeable or refundable.</li>
            </ol>

            {/* TIMEFRAME */}
            <h4>Timeframe:</h4>

            <ol>
              <li>
                Exchange requests must be raised within <strong>2 days</strong>{" "}
                of receiving the order.
              </li>
            </ol>

            {/* RESTRICTIONS */}
            <h4>Restrictions:</h4>

            <ol>
              <li>
                Once an order is exchanged, customers cannot request another
                exchange.
              </li>

              <li>
                If customer wishes to return the item, only a{" "}
                <strong>credit note</strong> will be issued.
              </li>
            </ol>

            {/* DELIVERY */}
            <h4>Delivery:</h4>

            <p>
              Exchange/replacement items will be delivered to the same address
              as the original order.
            </p>
          </div>
        )}

        {/* =====================================================
            REVIEWS
        ====================================================== */}
        {activeTab === "reviews" && (
          <p>Customer reviews will be displayed here.</p>
        )}
      </div>
    </div>
  );
};

export default ProductTabs;
